export enum KioskPreferencesQuestionsIds {
  CHECK_IN = 'checkIn',
  CHECK_OUT = 'checkOut',
}

export enum ExternalServiceStatus {
  UP= 'UP',
  HAS_ISSUES='HAS_ISSUES',
  MAINTENANCE ='MAINTENANCE',
  NOT_APPLICABLE='NOT_APPLICABLE'
}

export const UPDATE_FIXED_CACHE_KEY = 'UPDATE/SELF_SERVICE';
export const FINALIZE_FIXED_CACHE_KEY = 'FINALIZE/SELF_SERVICE';
